import sessionEvents from 'events/session';

export default function updateWelcomeMessage(welcomeMessage) {
  return dispatch => {
    dispatch(sessionEvents.setSessionWelcomeMessage(welcomeMessage));
  };
}
